window.Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.ProductTypeChange = (function () {
  function handleProductTypeChange() {
    // Dynamically load product type custom attributes
    const productTypeSelect = $('#product_product_type_id');
    const product_id = $('#product').data('id');

    productTypeSelect.change(function () {
      const formField = $(this);
      const fieldsWrapper = $('#product_type_attributes_wrapper');
      const spinnerContainer = $('[data-spin=product-type-change]');

      const product_type_id = $.trim(formField.val());
      if (product_type_id) {
        spinnerContainer.spin();
        $.get(formField.attr('rel'), { product_id, product_type_id }, (response) => {
          fieldsWrapper.html(response);
          spinnerContainer.stopSpinner();
        }).fail(() => {
          fieldsWrapper.html('');
        });
      } else {
        fieldsWrapper.html('');
      }
    });

    productTypeSelect.change();
  }

  function init() {
    handleProductTypeChange();
  }

  return {
    init,
  };
}());

$(document).ready(Reverb.Listing.ProductTypeChange.init);



// WEBPACK FOOTER //
// ./src/components/legacy/listing/product_type_change.js